import { BaseModel, HasId } from '@app/shared/models/base';
import { DisplayName } from '@app/shared/components/select/base-select-with-id.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as _ from 'lodash-es';
import { TranslationEntry } from '@app/shared/models/translatable';


export class ParticipantTypes {

    public static readonly ALL: TranslationEntry[] = [
        { key: 'ASSESSOR', trans: marker('participant.types.assessor')} ,
        { key: 'ACCIDENT_LOCATION', trans: marker('participant.types.accident_location')} ,
        { key: 'ACCIDENT_OPPONENT_INSURANCE', trans: marker('participant.types.accident_opponent_insurance')} ,
        { key: 'ACCIDENT_OPPONENT_POLICY_HOLDER', trans: marker('participant.types.accident_opponent_policy_holder')} ,
        { key: 'ACCIDENT_OPPONENT_VEHICLE_DRIVER', trans: marker('participant.types.accident_opponent_vehicle_driver')} ,
        { key: 'ACCIDENT_OPPONENT_VEHICLE_OWNER', trans: marker('participant.types.accident_opponent_vehicle_owner')} ,
        { key: 'BODYSHOP', trans: marker('participant.types.body_shop')} ,
        { key: 'CUSTOMER', trans: marker('participant.types.customer')} ,
        { key: 'DRIVER', trans: marker('participant.types.driver')} ,
        { key: 'LAWYER', trans: marker('participant.types.lawyer')} ,
        { key: 'LEGAL_EXPENSES_INSURANCE', trans: marker('participant.types.legal_expenses_insurance')} ,
        { key: 'POLICY_HOLDER', trans: marker('participant.types.policy_holder')} ,
        { key: 'RENTAL_CAR_COMPANY', trans: marker('participant.types.rental_car_company')} ,
        { key: 'SALES_MANAGER', trans: marker('participant.types.sales_manager')} ,
        { key: 'SERVICE_CONSULTANT', trans: marker('participant.types.service_consultant')} ,
        { key: 'TOWING_COMPANY', trans: marker('participant.types.towing_company')} ,
        { key: 'VEHICLE_HOLDER', trans: marker('participant.types.vehicle_holder')} ,
        { key: 'VEHICLE_INSURANCE', trans: marker('participant.types.vehicle_insurance')} ,
        { key: 'VEHICLE_LOCATION', trans: marker('participant.types.vehicle_location')} ,
        { key: 'VEHICLE_OWNER', trans: marker('participant.types.vehicle_owner')} ,
        { key: 'WITNESS', trans: marker('participant.types.witness')} ,
        { key: 'CLERK', trans: marker('participant.types.clerk')}
    ];

    public static getTypeByKey(key: string): TranslationEntry {
        return _.find(ParticipantTypes.ALL, (type: TranslationEntry) => type.key === key);
    }

    public static ALL_BUT(keys: string[]): TranslationEntry[] {
        return _.filter(ParticipantTypes.ALL, (type) => keys.indexOf(type.key) === -1);
    }

    public static get ASSESSOR() {
        return ParticipantTypes.getTypeByKey('ASSESSOR');
    }

    public static get ACCIDENT_LOCATION() {
        return ParticipantTypes.getTypeByKey('ACCIDENT_LOCATION');
    }

    public static get ACCIDENT_OPPONENT_INSURANCE() {
        return ParticipantTypes.getTypeByKey('ACCIDENT_OPPONENT_INSURANCE');
    }

    public static get ACCIDENT_OPPONENT_POLICY_HOLDER() {
        return ParticipantTypes.getTypeByKey('ACCIDENT_OPPONENT_POLICY_HOLDER');
    }

    public static get ACCIDENT_OPPONENT_VEHICLE_DRIVER() {
        return ParticipantTypes.getTypeByKey('ACCIDENT_OPPONENT_VEHICLE_DRIVER');
    }

    public static get ACCIDENT_OPPONENT_VEHICLE_OWNER() {
        return ParticipantTypes.getTypeByKey('ACCIDENT_OPPONENT_VEHICLE_OWNER');
    }

    public static get BODY_SHOP() {
        return ParticipantTypes.getTypeByKey('BODYSHOP');
    }

    public static get CUSTOMER() {
        return ParticipantTypes.getTypeByKey('CUSTOMER');
    }

    public static get DRIVER() {
        return ParticipantTypes.getTypeByKey('DRIVER');
    }

    public static get LAWYER() {
        return ParticipantTypes.getTypeByKey('LAWYER');
    }

    public static get LEGAL_EXPENSES_INSURANCE() {
        return ParticipantTypes.getTypeByKey('LEGAL_EXPENSES_INSURANCE');
    }

    public static get POLICY_HOLDER() {
        return ParticipantTypes.getTypeByKey('POLICY_HOLDER');
    }

    public static get RENTAL_CAR_COMPANY() {
        return ParticipantTypes.getTypeByKey('RENTAL_CAR_COMPANY');
    }

    public static get SALES_MANAGER() {
        return ParticipantTypes.getTypeByKey('SALES_MANAGER');
    }

    public static get SERVICE_CONSULTANT() {
        return ParticipantTypes.getTypeByKey('SERVICE_CONSULTANT');
    }

    public static get TOWING_COMPANY() {
        return ParticipantTypes.getTypeByKey('TOWING_COMPANY');
    }

    public static get VEHICLE_HOLDER() {
        return ParticipantTypes.getTypeByKey('VEHICLE_HOLDER');
    }

    public static get VEHICLE_INSURANCE() {
        return ParticipantTypes.getTypeByKey('VEHICLE_INSURANCE');
    }

    public static get VEHICLE_LOCATION() {
        return ParticipantTypes.getTypeByKey('VEHICLE_LOCATION');
    }

    public static get VEHICLE_OWNER() {
        return ParticipantTypes.getTypeByKey('VEHICLE_OWNER');
    }

    public static get WITNESS() {
        return ParticipantTypes.getTypeByKey('WITNESS');
    }

    public static get CLERK() {
        return ParticipantTypes.getTypeByKey('CLERK');
    }
}

export class ParticipantSubTypes {

    public static readonly ALL: TranslationEntry[] = [
        { key: 'PARTICIPANT', trans: marker('participant.sub_types.participant')} ,
        { key: 'WITNESS', trans: marker('participant.sub_types.witness')} ,
        { key: 'OTHER', trans: marker('participant.sub_types.other')}
    ];

    public static getTypeByKey(key: string): TranslationEntry {
        return _.find(this.ALL, (type: TranslationEntry) => type.key === key);
    }

    public static get PARTICIPANT() {
        return ParticipantSubTypes.getTypeByKey('PARTICIPANT');
    }

    public static get WITNESS() {
        return ParticipantSubTypes.getTypeByKey('WITNESS');
    }

    public static get OTHER() {
        return ParticipantSubTypes.getTypeByKey('OTHER');
    }
}

export class ParticipantType extends BaseModel implements HasId, DisplayName {
    public type: string;
    public selected?: boolean;
    public available?: boolean;
    public translation?: string;

    get id() {
        return this.type;
    }

    get displayName() {
        return this.translation || this.type;
    }

    constructor(json?: any) {
        super(json);
    }
}
